






import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Request {
    advertiserLabel: string;
}

@Component({ components: { SimpleText } })
export default class Number extends Vue {
    @Prop( { default: null }) public request !: Request;

    public static getNeededFields(): string[] {
        return [
            "request.code",
            "request.uuid",
            "request.children.code",
            "request.children.uuid"
        ];
    }
}
